import {makeReducer, match} from 'web-app/util/redux';

import {close, type ModalState, open} from '../types';
import * as Actions from './actions';

type State = {isInternal: true; onSuccess?: () => void} | {isInternal: false};

export type AchInstantVerificationModalState = ModalState<State>;

export default makeReducer<AchInstantVerificationModalState>(
    [
        match(Actions.show, (_, {payload}) => {
            if (payload.isInternal) {
                return open<State>({
                    isInternal: true,
                    onSuccess: payload.onSuccess,
                });
            }

            return open<State>({
                isInternal: false,
            });
        }),
        match(Actions.hide, () => close()),
    ],
    close(),
);
